/* 🤖 this file was generated by svg-to-ts */
export const waytrAnalytics = {
    name: 'analytics',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M26.22,2.62c-.41,0-.74,.33-.74,.74V21.88c0,.41,.33,.74,.74,.74h18.52c.41,0,.74-.33,.74-.74,0-10.63-8.63-19.26-19.26-19.26Zm-4.34,4.33c-10.63,0-19.26,8.63-19.26,19.26,0,10.63,8.63,19.27,19.26,19.27,10.63,0,19.27-8.64,19.27-19.27,0-.41-.33-.74-.74-.74H22.62V7.69c0-.41-.33-.74-.74-.74,0,0,0,0,0,0Z"/></svg>`,
};
